import { useMemo } from 'react';

import { ListPagination } from 'src/common/components';
import { Table } from 'src/common/components/Table';
import { PhoneProps } from 'src/tcr/types';

import { usePhoneListContext } from '../context';

interface PhoneListProps {
  phones: PhoneProps[];
}

export const PhoneList = ({ phones }: PhoneListProps): JSX.Element => {
  const { actions, state } = usePhoneListContext();
  const { loadingPhones, currentPage, totalCount, selectedPhones } = state;
  const { setSelectedPhones, paginate } = actions;

  const columns = useMemo(() => {
    return [
      { title: 'Number', index: 'number' },
      { title: 'Account', index: 'account.name' },
      {
        title: 'Campaign',
        index: 'campaign.campaign_id',
        renderer: (item: PhoneProps) => (
          <div>
            <div>{item.campaign?.campaign_id}</div>
            <div className="text-xs text-gray-2.0">{item.campaign?.description}</div>
          </div>
        ),
      },
      {
        title: 'Brand',
        index: 'brand.brand_id',
        renderer: (item: PhoneProps) => (
          <div>
            <div>{item.brand?.brand_id}</div>
            <div className="text-xs text-gray-2.0">{item.brand?.reference_id}</div>
          </div>
        ),
      },
    ];
  }, []);

  const handleSelect = (selected: string[]): void => {
    setSelectedPhones(selected);
  };

  return (
    <>
      <div className="scrollbar-thin flex-1 overflow-auto">
        <Table<PhoneProps>
          data={phones}
          columns={columns}
          showSelection
          onSelect={handleSelect}
          loading={loadingPhones}
          selected={selectedPhones}
          fieldId="number"
        />
      </div>
      <ListPagination currentPage={currentPage} totalCount={totalCount} setCurrentPage={paginate} />
    </>
  );
};
